export function ContactMap() {
  return (
    <section className="bg-paper py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">Visit Us</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-ink">Find Us in Purulia</h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div className="overflow-hidden rounded-lg border border-line">
            <iframe
              title="Bharat Consultancy location map"
              width="100%"
              height="320"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://maps.google.com/maps?q=Aradhya%20Complex%2C%20SN%20Sarkar%20St%2C%20Munsifdanga%2C%20Purulia%2C%20West%20Bengal%20723101&output=embed"
            />
          </div>

          <div className="flex flex-col justify-center">
            <h3 className="font-display text-xl font-semibold text-ink">Bharat Consultancy</h3>
            <address className="mt-3 not-italic leading-relaxed text-ink/70">
              2nd Floor, Aradhya Complex, SN Sarkar St,
              <br />
              Munsifdanga, Purulia, West Bengal 723101
            </address>
            <p className="mt-4 text-ink/70">
              Phone:{' '}
              <a href="tel:+918170896296" className="font-medium text-seal-blue">
                81708 96296
              </a>
            </p>
            <p className="text-ink/70">
              WhatsApp:{' '}
              <a href="https://wa.me/918170896296" className="font-medium text-seal-blue">
                81708 96296
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
